import { useSelector } from 'react-redux';

export const useIsFeaturesLoaded = () => {
  return useSelector(state => state.company?.features?.loaded || false);
};
